/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The DateBoundary model module.
 * @module model/DateBoundary
 * @version v0
 */
export default class DateBoundary {
  /**
   * Constructs a new <code>DateBoundary</code>.
   * @alias module:model/DateBoundary
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>DateBoundary</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DateBoundary} obj Optional instance to populate.
   * @return {module:model/DateBoundary} The populated <code>DateBoundary</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DateBoundary();
      if (data.hasOwnProperty('number1'))
        obj.number1 = ApiClient.convertToType(data['number1'], 'Number');
      if (data.hasOwnProperty('number2'))
        obj.number2 = ApiClient.convertToType(data['number2'], 'Number');
      if (data.hasOwnProperty('useNumber1'))
        obj.useNumber1 = ApiClient.convertToType(data['useNumber1'], 'Boolean');
      if (data.hasOwnProperty('useNumber2'))
        obj.useNumber2 = ApiClient.convertToType(data['useNumber2'], 'Boolean');
      if (data.hasOwnProperty('reversed'))
        obj.reversed = ApiClient.convertToType(data['reversed'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Number} number1
 */
DateBoundary.prototype.number1 = undefined;

/**
 * @member {Number} number2
 */
DateBoundary.prototype.number2 = undefined;

/**
 * @member {Boolean} useNumber1
 */
DateBoundary.prototype.useNumber1 = undefined;

/**
 * @member {Boolean} useNumber2
 */
DateBoundary.prototype.useNumber2 = undefined;

/**
 * @member {Boolean} reversed
 */
DateBoundary.prototype.reversed = undefined;

